export default __webpack_public_path__ + "static/media/sendMsg.1eaec574.svg";